<template>
  <b-button
    variant="link"
    size="sm"
    class="p-2"
    v-on="$listeners">
    <b-icon-chevron-up
      v-if="open" />
    <b-icon-chevron-down
      v-else />
  </b-button>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style>

</style>